// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

import HailIcon from '@mui/icons-material/Hail';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import ListAltIcon from '@mui/icons-material/ListAlt';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

const icoMenu = {
    HailIcon,
    GroupsIcon,
    PersonAddAlt1Icon,
    ListAltIcon,
    CurrencyExchangeIcon
}

// ==============================|| PROVEEDORES MENU ITEMS ||============================== //

const proveedor = {
    id: 'proveedor',
    title: '',
    type: 'group',
    children: [
        {
            id: 'proveedorMainMenu',
            title: 'Proveedores',
            type: 'collapse',
            icon: icoMenu.HailIcon,
            children: [
                {
                    id: 'grupo_proveedores',
                    title: 'Grupos Proveedores',
                    type: 'item',
                    icon: icoMenu.GroupsIcon,
                    url: '/user/list-grupo-proveedores-view'
                },
                {
                    id: 'nuevo_proveedor',
                    title: 'Nuevo Proveedor',
                    type: 'item',
                    icon: icoMenu.PersonAddAlt1Icon,
                    url: '/user/new-proveedores/0'
                },
                {
                    id: 'lista_proveedores',
                    title: 'Lista Proveedores',
                    type: 'item',
                    icon: icoMenu.ListAltIcon,
                    url: '/user/list-proveedores-view'
                },
                {
                    id: 'cuentas_pagar_proveedores',
                    title: 'Cuentas por Pagar',
                    type: 'item',
                    icon: icoMenu.CurrencyExchangeIcon,
                    url: '/user/cuentas-pagar-proveedores-view'
                },                
            ]
        }
    ]
};

export default proveedor;
